import prependNoneOption from 'src/compass/shared/util/prependNoneOption';

import prependAllOption from '../../util/prependAllOption';
import prependEmptyOption from '../../util/prependEmptyOption';
import { useRetrieveEntityList } from './useRetrieveEntityList';

export type EntityListOptionsProps = {
  includeAllOption?: boolean;
  includeNoneOption?: boolean;
  includeEmptyOption?: boolean;
  params?: Record<string, any>
  staleTime?: number;
};

type Props = EntityListOptionsProps & {
  entity: string;
  staleTime?: number;
};

export default function useRetrieveEntityListOptions({
  entity,
  includeAllOption = false,
  includeNoneOption = false,
  includeEmptyOption = false,
  params = {},
  staleTime,
}: Props) {
  const { data, isLoading } = useRetrieveEntityList({ entity, params, staleTime });

  let options = data?.result || [];
  if (includeEmptyOption) options = prependEmptyOption(options);
  if (includeAllOption) options = prependAllOption(options);
  if (includeNoneOption) options = prependNoneOption(options);

  return { options, isLoading };
}
